import { render, staticRenderFns } from "./NuevaBandejaEE.vue?vue&type=template&id=1204b562&scoped=true"
import script from "./NuevaBandejaEE.vue?vue&type=script&lang=js"
export * from "./NuevaBandejaEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204b562",
  null
  
)

export default component.exports